// inka Shopify Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Mobile Menu
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuOverlay = document.querySelector('[data-menu-overlay]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.add('is-open');
      menuOverlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    });

    const closeMenu = function() {
      mobileMenu.classList.remove('is-open');
      menuOverlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    };

    if (menuClose) {
      menuClose.addEventListener('click', closeMenu);
    }

    if (menuOverlay) {
      menuOverlay.addEventListener('click', closeMenu);
    }
  }

  // Product Page - Thumbnail Gallery
  const thumbnails = document.querySelectorAll('.product__thumbnail');
  const mainImage = document.getElementById('product-main-image');

  if (thumbnails.length && mainImage) {
    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        // Update active state
        thumbnails.forEach(t => t.classList.remove('product__thumbnail--active'));
        this.classList.add('product__thumbnail--active');
        
        // Update main image
        const newImageUrl = this.dataset.imageUrl;
        mainImage.src = newImageUrl;
      });
    });
  }

  // Product Page - Quantity Selector
  const quantityBtns = document.querySelectorAll('.product__quantity-btn');
  
  quantityBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const input = this.parentElement.querySelector('.product__quantity-input');
      const currentValue = parseInt(input.value) || 1;
      const action = this.dataset.action;

      if (action === 'increase') {
        input.value = currentValue + 1;
      } else if (action === 'decrease' && currentValue > 1) {
        input.value = currentValue - 1;
      }
    });
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        const headerHeight = document.querySelector('.header').offsetHeight;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});
